import { makeStyles } from "tss-react/mui";

export const MiWorkBoard = ({ children }: { children: React.ReactNode }) => {
  const { classes } = useStyles();

  return <div className={classes.boardContainer}>{children}</div>;
};

const useStyles = makeStyles()((theme) => ({
  boardContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "auto",
    backgroundColor: theme.palette.common.white,
  },
}));
